import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { WinnerStats } from '../../../widgets/result-banner';
import { r, vw, tabletUp } from '../../../shared/lib/responsive';
import { PromoCtaWrapAnimated } from '../../../shared/ui/promo-cta';

export const PageRoot = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const ScrollBody = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
`;

/** 스크롤 콘텐츠 — Main(812) + 프로모 배너(812px 지점부터 음수 margin으로 당김) */
export const ScrollCanvas = styled.div`
  position: relative;
  ${r('min-height', 949)}
`;

export const Main = styled.main`
  position: relative;
  ${r('height', 812)}
  pointer-events: none;
`;

export const BannerWrap = styled.div<{ $visible?: boolean }>`
  position: absolute;
  ${r('top', 70)}
  left: 50%;
  z-index: 2;
  transform: translateX(-50%);
  width: 100%;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.35s ease 0.1s;

  ${(p) =>
    p.$visible &&
    css`
      opacity: 1;
    `}
`;

export const Winner = styled.section`
  position: absolute;
  ${r('top', 217)}
  left: 50%;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  transform: translateX(-50%);
`;

export const WinnerCard = styled.div<{ $visible?: boolean }>`
  ${r('width', 189)}
  transform: translateY(var(--winner-card-lift));
  transition: transform 0.72s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    transform: translateY(0);
  }

  ${(p) =>
    p.$visible &&
    css`
      transform: translateY(0);
    `}
`;

export const RevealWinnerStats = styled(WinnerStats)<{ $visible?: boolean }>`
  ${r('margin-top', 20)}
  opacity: 0;
  transition: opacity 0.4s ease 0.48s;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    opacity: 1;
  }

  ${(p) =>
    p.$visible &&
    css`
      opacity: 1;
    `}
`;

/**
 * 스크롤 여유 — 고정 하단 슬롯(가맹점 ↔ 프로모 배너) 교차 페이드 트리거용.
 * Figma 115:1908 — 4위 행 하단(714) + 16px 간격 뒤 배너 구간 높이 유지.
 */
export const ScrollBottomSpacer = styled.section`
  position: relative;
  z-index: 2;
  ${r('margin-top', -82)}
  ${r('min-height', 133)}
  ${r('padding-bottom', 86)}
  pointer-events: none;
`;

const bottomSlotMotion = css`
  opacity: 0;
  transform: translateY(${vw(12)});

  ${tabletUp} {
    transform: translateY(12px);
  }

  transition:
    opacity 0.55s ease-out,
    transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
    transform: translateY(0);
  }
`;

const bottomSlotVisible = css`
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
`;

export const FixedOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 4;
  pointer-events: none;
`;

export const HeaderWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  pointer-events: auto;
`;

export const Footer = styled.footer`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 4;
`;

/** Figma 115:1966 — 가맹점 정보 (스크롤 전) */
export const Restaurant = styled.div<{ $visible?: boolean }>`
  position: absolute;
  ${r('top', 654)}
  left: var(--cta-margin-x);
  right: var(--cta-margin-x);
  pointer-events: none;
  ${bottomSlotMotion}

  ${tabletUp} {
    top: calc(654px - var(--bottom-slot-pc-offset-up));
  }

  ${(p) => p.$visible && bottomSlotVisible}
`;

/** Figma 136:10960 — 프로모 배너 (가맹점 스낵바와 동일한 CTA 간격 12px) */
export const PromoBanner = styled.div<{ $visible?: boolean }>`
  position: absolute;
  left: var(--cta-margin-x);
  right: var(--cta-margin-x);
  bottom: calc(var(--cta-bottom) + var(--cta-height) + var(--bottom-slot-gap-cta));
  pointer-events: none;
  ${bottomSlotMotion}

  ${tabletUp} {
    bottom: calc(
      var(--cta-bottom) + var(--cta-height) + var(--bottom-slot-gap-cta) +
        var(--bottom-slot-pc-offset-up)
    );
  }

  ${(p) => p.$visible && bottomSlotVisible}
`;

export const CtaWrap = PromoCtaWrapAnimated;
